<template>
  <ModalContainer
    :showModal="showModal"
    title="Detail Transaction"
    @closeModal="closeModal"
  >
    <div id="modal-body" class="p-4 h-96 overflow-y-scroll">
      <div class="mb-6 text-center">
        <h5 class="font-semibold text-xl">
          {{ transactionDetail?.Customer?.name }}
        </h5>
        <p class="text-sm">
          {{ formatDate(transactionDetail?.transaction_date) }}
        </p>
      </div>
      <div class="grid grid-cols-3 gap-4 mb-4">
        <p class="text-sm font-light col-span-1">Branch :</p>
        <h5 class="font-semibold col-span-2 text-end">{{ transactionDetail?.Branch?.name }}</h5>
      </div>
      <div class="flex flex-col justify-between mb-4">
        <p class="text-sm font-light">Products :</p>
        <ul>
          <li
            v-for="product in transactionDetail?.ProductTransactions"
            :key="product.product_id"
          >
            <div class="flex justify-between items-center">
              {{ product.Product.products_name }}
              <span>x {{ product.quantity }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="flex justify-between mb-4">
        <p class="text-sm font-light">Subtotal :</p>
        <h5 class="font-semibold">
          {{ formatRupiah(transactionDetail?.subtotal) }}
        </h5>
      </div>
      <div class="flex justify-between mb-4">
        <p class="text-sm font-light">Discount :</p>
        <h5 class="font-semibold">
          {{ formatRupiah(transactionDetail?.discount) }}
        </h5>
      </div>
      <div class="flex justify-between mb-4">
        <p class="text-sm font-light">Grand Total :</p>
        <h5 class="font-semibold">
          {{ formatRupiah(transactionDetail?.grand_total) }}
        </h5>
      </div>
    </div>
    <div class="modal-footer pb-6">
      <div class="flex justify-center gap-2">
        <Button id="close-modal" button_text="Close" @click="closeModal" />
      </div>
    </div>
  </ModalContainer>
</template>

<script>
import ModalContainer from "@/components/modals/ModalContainer.vue";
import Button from "@/components/buttons/Button.vue";
import { formatDate, formatRupiah } from "@/helpers/formating";

export default {
  name: "ModalEditCustomer",
  props: {
    transactionDetail: {
      type: Object,
      default: {},
    },
  },
  components: {
    ModalContainer,
    Button,
  },
  data() {
    return {
      showModal: true,
    };
  },
  created() {
    console.log(this.transactionDetail);
  },
  methods: {
    formatDate,
    formatRupiah,
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },
  },
};
</script>
